var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "boss-message-heading" },
    [
      _c(
        "div",
        {
          staticClass: "boss-message-heading-when",
          attrs: { "data-test": "date" },
        },
        [_vm._v("\n    " + _vm._s(_vm._f("formatDate")(_vm.date)) + "\n  ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "boss-message-heading-title",
          attrs: { "data-test": "entry-info" },
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(_vm.fullName) +
              "さんが『求人ID：" +
              _vm._s(_vm.job.id) +
              " " +
              _vm._s(_vm.job.name) +
              "』に応募しました。\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _vm.showSpecialFavor
        ? [
            _c(
              "div",
              {
                staticClass: "boss-message-heading-text",
                attrs: { "data-test": "scout-special-favor" },
              },
              [_vm._v("\n      スカウト特典があります！\n    ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "boss-bonus-check-group" },
              [
                _vm._l(_vm.specialFavors, function (specialFavor, i) {
                  return [
                    specialFavor.isEffective
                      ? _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: {
                                  content: _vm.specialFavorBy(specialFavor.id)
                                    .description,
                                },
                                expression:
                                  "{ content: specialFavorBy(specialFavor.id).description}",
                              },
                            ],
                            key: i,
                            staticClass:
                              "boss-bonus-check-text boss-check-true",
                            attrs: { "data-test": "special-favor-" + i },
                          },
                          [_vm._v(_vm._s(specialFavor.name))]
                        )
                      : _vm._e(),
                  ]
                }),
              ],
              2
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }